var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_257_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.18 27.13V28.19M28.18 12.19V22.83M32.24 28.15H41.72C41.9821 28.1232 42.2328 28.0287 42.4474 27.8758C42.6619 27.7229 42.8331 27.5168 42.944 27.2778C43.0549 27.0388 43.1018 26.7751 43.0801 26.5125C43.0583 26.25 42.9687 25.9975 42.82 25.78L29.28 4.32001C29.1686 4.12687 29.0082 3.96649 28.8152 3.85498C28.6221 3.74347 28.403 3.68475 28.18 3.68475C27.957 3.68475 27.738 3.74347 27.5449 3.85498C27.3518 3.96649 27.1915 4.12687 27.08 4.32001L13.53 25.78C13.3813 25.9975 13.2917 26.25 13.27 26.5125C13.2482 26.7751 13.2951 27.0388 13.4061 27.2778C13.517 27.5168 13.6881 27.7229 13.9027 27.8758C14.1173 28.0287 14.3679 28.1232 14.63 28.15H24.11M14.35 31.34V34.28C15.2047 34.8508 15.8532 35.6812 16.1997 36.6488C16.5461 37.6164 16.5722 38.6698 16.274 39.6533C15.9758 40.6369 15.3691 41.4984 14.5437 42.1107C13.7183 42.723 12.7178 43.0536 11.69 43.0536C10.6623 43.0536 9.66178 42.723 8.83633 42.1107C8.01089 41.4984 7.40427 40.6369 7.10608 39.6533C6.80789 38.6698 6.83394 37.6164 7.18039 36.6488C7.52684 35.6812 8.17532 34.8508 9.03003 34.28V3.19C9.03003 2.48453 9.31027 1.80796 9.80911 1.30911C10.308 0.810266 10.9845 0.530029 11.69 0.530029C12.3955 0.530029 13.0721 0.810266 13.5709 1.30911C14.0698 1.80796 14.35 2.48453 14.35 3.19V17.58M4.77002 5.88H0.52002M4.77002 31.41H0.52002M4.77002 27.16H2.64003M4.77002 22.9H2.64003M4.78003 18.58H0.530029M4.78003 14.32H2.65002M4.78003 10.06H2.65002",
    stroke: "white",
    strokeWidth: 1.06,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_257_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.62,
    height: 43.62,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleIcon6);
export default __webpack_public_path__ + "static/media/purple-icon-6.7f43d2b862bfd6f03662e1ed93c0f799.svg";
export { ForwardRef as ReactComponent };